export const canShowPDPMeasurements = (config?: string) => config === 'true';
